export default __webpack_public_path__ + "static/media/projectsIcon.ecf47110.svg";